import React from "react";
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";

export const AiSummaryHeaderSkeleton: React.FC = () => {
    return (
        <Card className="p-3 mb-3">
            <div className="flex align-items-center justify-content-between mb-3">
                <Skeleton width="120px" height="1.5rem" />
                <div className="flex gap-2">
                    <Skeleton width="100px" height="2rem" />
                    <Skeleton width="100px" height="2rem" />
                </div>
            </div>
            <div className="flex align-items-center gap-3 mb-3">
                <Skeleton shape="circle" size="3rem" />
                <Skeleton width="300px" height="1rem" />
            </div>
            <Skeleton width="100%" height="4rem" />
        </Card>
    );
};

export const AiSummarySectionsSkeleton: React.FC = () => {
    return (
        <div className="grid">
            {Array.from({ length: 3 }, (_, index) => (
                <div key={index} className="col-12 mb-4">
                    <Card className="shadow-2">
                        <div className="flex align-items-center justify-content-between mb-3">
                            <div className="flex align-items-center gap-3">
                                <Skeleton width="200px" height="2rem" />
                                <div className="flex gap-2">
                                    <Skeleton width="120px" height="1.5rem" borderRadius="16px" />
                                </div>
                            </div>
                            <Skeleton width="40px" height="2rem" />
                        </div>
                        
                        {index === 0 && (
                            <div className="grid">
                                <div className="col-6">
                                    <Skeleton width="100%" height="300px" className="mb-3" />
                                </div>
                                <div className="col-6">
                                    <Skeleton width="100%" height="300px" className="mb-3" />
                                </div>
                            </div>
                        )}
                        
                        {index !== 0 && (
                            <div className="text-center py-3">
                                <Skeleton width="150px" height="1rem" />
                            </div>
                        )}
                    </Card>
                </div>
            ))}

            {/* Save All Button Skeleton */}
            <Card className="mt-4 shadow-2">
                <div className="flex justify-content-center">
                    <Skeleton width="200px" height="3rem" />
                </div>
            </Card>
        </div>
    );
};